import React, { useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { loadFiles, setOutputFileAttribute, updateFileReviewStatus } from './thunks';
import Switch from '@material-ui/core/Switch';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import './OutputFileTable.css';

const OutputFileTable = ({ 
  allowEdit = false, files = [], filesFiltered = [], userInfo, reviewInfo,
  startLoadingFiles, startSetOutputFileAttribute, 
  startUpdateFileReviewStatus }) => {

  useEffect(() => {
    // console.log('>>> filesFiltered changed', filesFiltered.length);
  }, [filesFiltered]);
  
  const handleSwitchChange = (event) => {
    event.preventDefault();
    const selectedFile =  event.target.getAttribute('name');
    const isFileComplete = event.target.checked;
    const fileData = { 
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      fileName: selectedFile,
      groupId: reviewInfo.groupId,
      isComplete: isFileComplete, 
      userId: userInfo.userId,
    };
    // console.log('>>> handleSwitchChange update fileData:', fileData);
    startUpdateFileReviewStatus(fileData);
  };
  
  const getFileTooltip = (filename) => {
    const [hoveredFile] = _.filter(filesFiltered, (file) => file.fileName === filename);
    // console.log('>>> hoveredFile:', filename, hoveredFile);
    let tooltipText = '';
    if (hoveredFile) {
      tooltipText = `${hoveredFile.output_number} ${hoveredFile.output_title}`;
    }
    return tooltipText;
  };
  
  const handleFileClick = (event) => {
    const fileName = event.target.parentElement.getAttribute('name');
    // console.log('>>> handleFileClick fileName:', fileName);
    startSetOutputFileAttribute({
      fileName: fileName,
      isSelected: true, 
    });
  };
  
  const getFileStatusImageUrl = (file) => {
    let imageUrl = '';  // "/images/status-o.png";
    let statusId = parseInt(file.statusId);
    switch (statusId) {
      case 1:
        imageUrl = '/images/status-i.png';
        break;
      case 2:
        imageUrl = '/images/status-b.png';
        break;
      case 3:
        imageUrl = '/images/status-l.png';
        break;
      case 4:
        imageUrl = '/images/status-o.png';
        break;
      case 5:
        imageUrl = '/images/status-e.png';
        break;
      default:
        imageUrl = '/images/status-x.png';
    }
    return imageUrl;
  }
  
  const getPrevGroupImageUrl = (file) => {
    let imageUrl = '/images/view-20.png';
    return imageUrl;
  }
  
  const handlePrevGroupClick = (event) => {
    const fileName = event.target.getAttribute('data-filename');
    const groupId = event.target.getAttribute('data-group');
    // use allFiles=true to get all files, not just is_active files
    const viewUrl = `view?program=${reviewInfo.program}&study=${reviewInfo.study}&` + 
      `milestone=${reviewInfo.milestone}&user=${userInfo.userId}&groupId=${groupId}&` + 
      `fileName=${fileName}&allFiles=true`;
    window.open(viewUrl,'last review on file');
  }
  
  const content = (
    <div className="file-list-table">
      <table>
        <tbody>
        <tr key="Header">
          {allowEdit ? <th key="C">Complete</th> : <th />}
          <th key="S">Status</th>
          <th key="T">Type</th>
          <th key="G"></th>
          <th key="F">Output File Name</th>
        </tr>
        {filesFiltered.map(file => 
          <tr key={file.updateDate}>
            {allowEdit ?
              <td key="C">
                <Switch
                  size="small"
                  color="primary"
                  checked={file.isComplete}
                  onChange={handleSwitchChange}
                  name={file.fileName}
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
              </td>
              : <th />}
            <td key="S">
              <img alt="" className="fileTypeIcon" src={ getFileStatusImageUrl(file) } />
            </td>
            <td key="T">
              <img alt="" className="fileTypeIcon" src={ "/images/type-" + file.outputType + ".png"} />
            </td>
            <td key="G">
              {file.prevGroups.length > 0 ?
              <img alt="" className="PrevGroupIcon" src={ getPrevGroupImageUrl(file) }
                data-filename = {file.fileName}
                data-group = {file.prevGroups[0]}
                onClick={handlePrevGroupClick} />
              : <img alt="" />}
            </td>
            <td className={'file-item file-selected-' + file.isSelected} 
              key={file.updateDate} name={file.fileName} 
              onClick={handleFileClick}>
              <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} 
                overlay={<Tooltip>{getFileTooltip(file.fileName)}</Tooltip>}>
                <div className="filename-text">
                  {file.fileName}
                </div>
              </OverlayTrigger>
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );
  return content;
}

const mapState = state => ({
  files: state.files,
  filesFiltered: state.filesFiltered,
  userInfo: state.userInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  startLoadingFiles: () => dispatch(loadFiles()),
  startSetOutputFileAttribute: (data) => dispatch(setOutputFileAttribute(data)),
  startUpdateFileReviewStatus: (data) => dispatch(updateFileReviewStatus(data)),
})

export default connect(mapState, mapDispatch)(OutputFileTable);
